(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);
    angular
    .module('nasracApp').directive('trackingcode', trackingcode);

    function trackingcode() {
		var directive = {
			restrict : 'E',
			templateUrl : 'app/trackingcode.directive.html',

			controller: ['$http', '$scope', function($http, $scope) {
				  var vm = this;
				  vm.siteid = $http.get('/api/nasrac-web-contents/page/piwik-siteid').then(function(result) {

					  var data = JSON.parse(result.data[0].content);
					  $scope.trackingcodevalue = data.siteId;
					  $scope.ipAddress = data.ipAddress;

	                  return data.siteId;
	                });

			}],
	        controllerAs: 'vm',
	        bindToController: true,

			scope : {
				trackingcodevalue : '=trackingcodevalue'
			},
			link : linkFunc,
		};

		return directive;

		function linkFunc(scope, el, attr, ctrl) {

			scope.$watch('trackingcodevalue', function(newVal, oldValue) {
				if (newVal){
                	var IDSITE = scope.trackingcodevalue;
                	var PIWIK_URL = scope.ipAddress;

					_paq.push([ 'trackPageView' ]);
					_paq.push([ 'enableLinkTracking' ]);
					(function() {
						var u = "//"+ PIWIK_URL +"/";
						_paq.push([ 'setTrackerUrl', u + 'piwik.php' ]);
						_paq.push([ 'setSiteId', IDSITE ]);
						var d = document, g = d.createElement('script'), s = d
						.getElementsByTagName('script')[0];
						g.type = 'text/javascript';
						g.async = true;
						g.defer = true;
						g.src = u + 'piwik.js';
						s.parentNode.insertBefore(g, s);
					})();

				}
			});
		}
	}

    stateConfig.$inject = ['$stateProvider','IdleProvider','KeepaliveProvider'];

    function stateConfig($stateProvider,IdleProvider,KeepaliveProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });

        IdleProvider.idle(900); // 15 minutes idle
        IdleProvider.timeout(30); // after 30 seconds idle, time the user out
        KeepaliveProvider.interval(5 * 60);
        IdleProvider.autoResume("notIdle");
    }
})();
